import { useEffect, useState } from "react";
import { keycloak } from "./utils/keycloak";
import MainHeader from "./components/header/MainHeader";
import NotFound from "./pages/404";
import BackToTop from "./components/BackToTop/BackToTop";
import Loader from "./components/loaders/Loader";
import { observer } from "mobx-react";
import { Row, Col, ConfigProvider } from "antd";
import { getStores, StoreProvider } from "./stores/stores";
import { Routes, Route, useLocation } from "react-router-dom";
import Marketplace from "./pages/Marketplace";
import Profile from "./pages/Profile";
import Wishlist from "./pages/Wishlist";
import Catalogue from "./pages/Catalogue";
import QandA from "./pages/QandApage";
import Messages from "./components/messages/Messages";
import Home from "./pages/Home";
import MessageBanner from "./components/messages/MessageBanner";
import CookieConsent from "./components/utils/CookieConsent";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import Footer from "./components/footer/Footer";
import Moderation from "./pages/Moderation";
import ItemDetailsPage from "./components/marketplace/ItemDetailsPage";
import MainLoaderModal from "./components/loaders/MainLoaderModal";
import RequestsList from "./components/Requests/RequestsList";
import RequestItemDetails from "./components/RequestItem/RequestItemDetails";
import { RequestsPage } from "./pages/RequestsPage";
import LearningGraphTool from "./pages/LearningGraphTool";
import CatalogueItemDetailsModal from "./components/CatalogueItemDetailsModal";

const App = (props) => {
  const mobxStores = getStores();
  const [loading, setLoading] = useState(true);

  const location = useLocation();
  const backgroundLocation = location.state?.backgroundLocation || location;

  useEffect(() => {
    const checkWalletConnection = async () => {
      if (window.ethereum) {
        const accounts = await window.ethereum.request({
          method: "eth_accounts",
        });
        if (accounts.length === 0) {
          localStorage.removeItem("metaMask");
        }
      }
    };

    checkWalletConnection();
    mobxStores.marketplaceStore.GetLicense();
    mobxStores.marketplaceStore.GetTags();
    if (keycloak.authenticated) {
      mobxStores.marketplaceStore.GetCart();
      mobxStores.userStore.GetUserRole();
    }

    mobxStores.ratingStore.GetRatings();
    setTimeout(() => setLoading(false), 2000);
  }, [
    mobxStores.userStore,
    mobxStores.marketplaceStore,
    mobxStores.ratingStore,
  ]);

  return loading ? (
    <ConfigProvider
      theme={{
        token: {
          colorPrimary: mobxStores.styleStore.primaryColor,
          fontSize: 15,
          colorText: "black",
          colorInfo: mobxStores.styleStore.primaryColor,
          lineWidth: 2,
        },
      }}
    >
      <Loader />
    </ConfigProvider>
  ) : (
    <ConfigProvider
      theme={{
        token: {
          colorPrimary: "rgb(201 42 213)",
          fontSize: 15,
          colorText: "black",
          colorInfo: mobxStores.styleStore.primaryColor,
          lineWidth: 2,
        },
        components: {
          Menu: {
            colorTextBase: "white",
          },
        },
      }}
    >
      <StoreProvider value={mobxStores}>
        {mobxStores.marketplaceStore.buyInProgress && <MainLoaderModal />}
        <Row className="full-viewport">
          <Col
            span={24}
            style={{
              display: "flex",
              flexDirection: "column",
              height: "100%",
            }}
            className={
              mobxStores.styleStore.styleClass +
              " " +
              mobxStores.styleStore.fontSize
            }
          >
            <MainHeader onLogout={props.onLogout} token={props.token} />
            <BackToTop />
            <Messages />
            <MessageBanner />
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/catalogue" element={<Catalogue />} />
              <Route path="/FAQ" element={<QandA />} />
              <Route path="/catalogue/:catalogueId" element={<Catalogue />} />
              <Route path="/marketplace" element={<Marketplace />} />
              <Route path="/marketplace/:pk" element={<ItemDetailsPage />} />
              <Route path="/portfolio/:username" element={<Profile />} />
              <Route path="/moderation" element={<Moderation />} />
              <Route path="/wishlist" element={<Wishlist />} />
              <Route path="/requests" element={<RequestsPage />}>
                <Route index element={<RequestsList />} />
                <Route path=":requestId" element={<RequestItemDetails />} />
              </Route>
              <Route
                path="/learning-graph-tool"
                element={<LearningGraphTool />}
              />
              <Route path="/privacy-policy" element={<PrivacyPolicy />} />
              <Route path="*" element={<NotFound />} />
            </Routes>
            {backgroundLocation !== location && (
              <Routes>
                <Route
                  path="/catalogue/:catalogueId"
                  element={<CatalogueItemDetailsModal />}
                />
              </Routes>
            )}
          </Col>
        </Row>
        <Footer />
        <CookieConsent />
      </StoreProvider>
    </ConfigProvider>
  );
};

export default observer(App);
